



































import Vue from "vue";
import Component from "vue-class-component";
import { MeService as meApi } from "@/common/api/services/MeService";
import { AuthMemberDTO, AuthService } from "@/common/api";
import EditProfilePopup from "@/sites/user/pages/mypage/popup/editProfile.vue";
import QErrors from "@/common/qErrors.vue";
import { namespace } from "vuex-class";
import { AppVersion } from "@/common/utils";

const auth = namespace("MemberAuth");

@Component({
  name: "Profile",
  components: {
    EditProfilePopup,
    QErrors,
  },
})
export default class Profile extends Vue {
  @auth.Action
  logout!: () => void;

  @auth.Getter
  getLoggingUser;

  member: AuthMemberDTO = {
    id: 0,
    name: "",
    email: "",
  };

  public appVersion = AppVersion();

  mounted() {
    this.getProfile();
    console.log("get profile");
  }

  async getProfile() {
    const result = await meApi.meProfile({});
    this.member = result.data.member;
  }

  showEditProfile() {
    (this.$refs.editProfile as EditProfilePopup).show();
  }

  async linkToLine() {
    const response = await AuthService.lineGetUrlUpdate({});
    const url = response.data.url;
    window.location.href = url;
  }
}
